import { useDeferredValue, useState } from 'react';
import { Input } from '@/components/ui';
import { usePatients } from '@/features/patients/api';
import type { PatientSummary } from '@/features/patients/types';
import { PatientIdentityText } from '@/pages/patients/PatientIdentityText';
import styles from './queue.module.css';

/** Find a registered patient by name, MyKad, passport or phone. */
export function PatientPicker({
  value,
  onChange,
  label = 'Patient',
}: {
  value: PatientSummary | null;
  onChange: (p: PatientSummary | null) => void;
  label?: string;
}) {
  const [q, setQ] = useState('');
  const deferred = useDeferredValue(q.trim());
  const { data, isFetching } = usePatients({
    q: deferred || undefined,
    pageSize: 6,
  });
  if (value) {
    return (
      <div className={styles.picked}>
        <div>
          <p className={styles.name}>{value.fullName}</p>
          <p className={styles.sub}>
            <PatientIdentityText identity={value.identity} />
          </p>
        </div>
        <button
          type="button"
          className={styles.linkButton}
          onClick={() => onChange(null)}
        >
          Change
        </button>
      </div>
    );
  }
  return (
    <div className={styles.picker}>
      <Input
        aria-label={label}
        placeholder="Name, MyKad, passport or phone"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />
      {deferred.length >= 2 && (
        <ul className={styles.results} aria-busy={isFetching}>
          {(data?.data ?? []).map((p) => (
            <li key={p.id}>
              <button type="button" onClick={() => onChange(p)}>
                <span className={styles.name}>{p.fullName}</span>
                <span className={styles.sub}>
                  <PatientIdentityText identity={p.identity} />
                </span>
              </button>
            </li>
          ))}
          {data && data.data.length === 0 && (
            <li className={styles.sub}>
              No registered patient matches. Register the patient first.
            </li>
          )}
        </ul>
      )}
    </div>
  );
}
